import e from "./ObjectUtils.js";
var t = function () {
  var t;
  function r() {
    !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, r);
  }
  return t = [{
    key: "filter",
    value: function value(t, n, l, i, o) {
      var a = [],
        u = e.removeAccents(l).toLocaleLowerCase(o);
      if (t) {
        var c = !0,
          m = !1,
          g = void 0;
        try {
          for (var s, f = t[Symbol.iterator](); !(c = (s = f.next()).done); c = !0) {
            var v = s.value,
              y = !0,
              T = !1,
              L = void 0;
            try {
              for (var h, w = n[Symbol.iterator](); !(y = (h = w.next()).done); y = !0) {
                var k = h.value,
                  C = e.removeAccents(String(e.resolveFieldData(v, k))).toLocaleLowerCase(o);
                if (r[i](C, u, o)) {
                  a.push(v);
                  break;
                }
              }
            } catch (e) {
              T = !0, L = e;
            } finally {
              try {
                y || null == w.return || w.return();
              } finally {
                if (T) throw L;
              }
            }
          }
        } catch (e) {
          m = !0, g = e;
        } finally {
          try {
            c || null == f.return || f.return();
          } finally {
            if (m) throw g;
          }
        }
      }
      return a;
    }
  }, {
    key: "startsWith",
    value: function value(t, r, n) {
      if (null == r || "" === r.trim()) return !0;
      if (null == t) return !1;
      var l = e.removeAccents(r.toString()).toLocaleLowerCase(n);
      return e.removeAccents(t.toString()).toLocaleLowerCase(n).slice(0, l.length) === l;
    }
  }, {
    key: "contains",
    value: function value(t, r, n) {
      if (null == r || "string" == typeof r && "" === r.trim()) return !0;
      if (null == t) return !1;
      var l = e.removeAccents(r.toString()).toLocaleLowerCase(n);
      return -1 !== e.removeAccents(t.toString()).toLocaleLowerCase(n).indexOf(l);
    }
  }, {
    key: "endsWith",
    value: function value(t, r, n) {
      if (null == r || "" === r.trim()) return !0;
      if (null == t) return !1;
      var l = e.removeAccents(r.toString()).toLocaleLowerCase(n),
        i = e.removeAccents(t.toString()).toLocaleLowerCase(n);
      return -1 !== i.indexOf(l, i.length - l.length);
    }
  }, {
    key: "equals",
    value: function value(t, r, n) {
      return null == r || "string" == typeof r && "" === r.trim() || null != t && (t.getTime && r.getTime ? t.getTime() === r.getTime() : e.removeAccents(t.toString()).toLocaleLowerCase(n) === e.removeAccents(r.toString()).toLocaleLowerCase(n));
    }
  }, {
    key: "notEquals",
    value: function value(t, r, n) {
      return null != r && ("string" != typeof r || "" !== r.trim()) && (null == t || (t.getTime && r.getTime ? t.getTime() !== r.getTime() : e.removeAccents(t.toString()).toLocaleLowerCase(n) !== e.removeAccents(r.toString()).toLocaleLowerCase(n)));
    }
  }, {
    key: "in",
    value: function value(t, r) {
      if (null == r || 0 === r.length) return !0;
      if (null == t) return !1;
      for (var n = 0; n < r.length; n++) if (e.equals(t, r[n])) return !0;
      return !1;
    }
  }, {
    key: "lt",
    value: function value(e, t) {
      return null == t || !!t.trim && 0 === t.trim().length || null != e && (e.getTime && t.getTime ? e.getTime() < t.getTime() : e < parseFloat(t));
    }
  }, {
    key: "lte",
    value: function value(e, t) {
      return null == t || !!t.trim && 0 === t.trim().length || null != e && (e.getTime && t.getTime ? e.getTime() <= t.getTime() : e <= parseFloat(t));
    }
  }, {
    key: "gt",
    value: function value(e, t) {
      return null == t || !!t.trim && 0 === t.trim().length || null != e && (e.getTime && t.getTime ? e.getTime() > t.getTime() : e > parseFloat(t));
    }
  }, {
    key: "gte",
    value: function value(e, t) {
      return null == t || !!t.trim && 0 === t.trim().length || null != e && (e.getTime && t.getTime ? e.getTime() >= t.getTime() : e >= parseFloat(t));
    }
  }], function (e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }(r, t), r;
}();
export { t as default };